<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "invoice",
  data() {
    return {
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159
        },
        {
          name: 'Ice cream sandwich',
          calories: 237
        },
        {
          name: 'Eclair',
          calories: 262
        },
        {
          name: 'Cupcake',
          calories: 305
        },
        {
          name: 'Gingerbread',
          calories: 356
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Invoice" }]);
  }
};
</script>
<style scoped>
.invoice-ribbon {
  width: 85px;
  height: 88px;
  overflow: hidden;
  position: absolute;
  top: -1px;
  right: 14px;
}

.ribbon-inner {
    text-align: center;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    position: relative;
    padding: 7px 0;
    left: -5px;
    top: 11px;
    width: 120px;
    background-color: #66c591;
    font-size: 15px;
    color: #fff;
}
</style>
<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-card
        elevation="2"
        class="mx-auto my-12 pa-10"
        max-width="600"
      >
        <div class="invoice-ribbon"><div class="ribbon-inner">PAID</div></div>
        <div class="title text-center">
          Invoice 599FA798-001
        </div>

        <div class="title mt-20 mb-10">
          Anna Smith<br>
          June 01 2015<br>
          <v-chip color="#66c591" dark>PAID</v-chip>
        </div>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="item in desserts"
                :key="item.name"
              >
                <td>{{ item.name }}</td>
                <td class="text-right">{{ item.calories }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top: #333 solid 5px; border-bottom: #333 solid 5px;">
                <td colspan="2" class="title font-weight-bold text-right">
                  TOTAL <span class="ml-10">$1,000.00</span>
                </td>
              </tr>
            </tfoot>
          </template>
        </v-simple-table>
      </v-card>
    </v-main>
  </v-app>
</template>
